import { Stack, Typography } from "@mui/material";

interface SettingsHeaderProps {
  title: string;
  active?: boolean;
  id?: string;
}
const SettingsHeader = ({ title, active, id }: SettingsHeaderProps) => {
  return (
    <Stack
      sx={{
        scrollMarginTop: "160px",
        boxSizing: "border-box",
        bgcolor: "shades.ghost.500",
        p: 2,
        borderRadius: "4px",
      }}
      id={id && id}
    >
      <Typography
        variant="h2"
        sx={{ color: active ? "shades.primary.500" : "shades.neutral.800" }}
      >
        {title}
      </Typography>
    </Stack>
  );
};

export default SettingsHeader;
